import { render } from "./PostSettingsSection.vue?vue&type=template&id=f5ceba30&scoped=true"
import script from "./PostSettingsSection.vue?vue&type=script&lang=js"
export * from "./PostSettingsSection.vue?vue&type=script&lang=js"

import "../../assets/widget.css?vue&type=style&index=0&id=f5ceba30&scoped=true&lang=css&external"
import "./PostSettingsSection.vue?vue&type=style&index=1&id=f5ceba30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ceba30"]])

export default __exports__